import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // acceptanceRate
  applicationsAccepted: {
    id: 'admissions.acceptanceRate.applicationsAccepted',
    defaultMessage: 'Applications Accepted',
  },
  applicationsReceived: {
    id: 'admissions.acceptanceRate.applicationsReceived',
    defaultMessage: 'Applications Received',
  },

  // fees
  applicationFee: {
    id: 'admissions.fees.applicationFee',
    defaultMessage: 'Application Fee',
  },
  deposit: {
    id: 'admissions.fees.deposit',
    defaultMessage: 'Deposit',
  },
  transferApplicationFee: {
    id: 'admissions.fees.transferApplicationFee',
    defaultMessage: 'Transfer Application Fee',
  },
  transferDepositFee: {
    id: 'admissions.fees.transferDepositFee',
    defaultMessage: 'Transfer Deposit Fee',
  },
  internationalApplicationFee: {
    id: 'admissions.fees.internationalApplicationFee',
    defaultMessage: 'International Application Fee',
  },
  internationalDepositFee: {
    id: 'admissions.fees.internationalDepositFee',
    defaultMessage: 'International Deposit Fee',
  },

  // importantPolicies
  admissionsPolicy: {
    id: 'admissions.importantPolicies.admissionsPolicy',
    defaultMessage: 'Admissions Policy',
  },
  notificationPolicy: {
    id: 'admissions.importantPolicies.notificationPolicy',
    defaultMessage: 'Notification Policy',
  },
  registrationPolicy: {
    id: 'admissions.importantPolicies.registrationPolicy',
    defaultMessage: 'Registration Policy',
  },
  earlyDecision: {
    id: 'admissions.importantPolicies.earlyDecision',
    defaultMessage: 'Early Decision',
  },
  waitingList: {
    id: 'admissions.importantPolicies.waitingList',
    defaultMessage: 'Waiting List',
  },
  field_he_intlbaccalaureateplcmid: {
    id: 'admissions.importantPolicies.field_he_intlbaccalaureateplcmid',
    defaultMessage: 'IB Placement',
  },
  field_he_clepsubjectplacement_id: {
    id: 'admissions.importantPolicies.field_he_clepsubjectplacement_id',
    defaultMessage: 'CLEP Placement',
  },
  field_he_ceebadvancedplacementid: {
    id: 'admissions.importantPolicies.field_he_ceebadvancedplacementid',
    defaultMessage: 'AP Placement',
  },
  field_he_clepcredit: {
    id: 'admissions.importantPolicies.field_he_clepcredit',
    defaultMessage: 'CLEP Credit accepted',
  },
  field_he_apcredit: {
    id: 'admissions.importantPolicies.field_he_apcredit',
    defaultMessage: 'AP Credit accepted',
  },
  deadlineWarning: {
    id: 'deadline.commonApp.warning',
    defaultMessage: 'Any changes to this deadline must be made directly through Common App only.',
  },
});

export default messages;
